module.exports = __webpack_public_path__ + "static/img/cCT3.d400432f.png";